import { render } from "./PublishersView.vue?vue&type=template&id=6eaac440&scoped=true"
import script from "./PublishersView.vue?vue&type=script&lang=js"
export * from "./PublishersView.vue?vue&type=script&lang=js"

import "./PublishersView.vue?vue&type=style&index=0&id=6eaac440&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eaac440"]])

export default __exports__